import { render } from "./DynvibeBarOpposite.vue?vue&type=template&id=4fb5f6d5"
import script from "./DynvibeBarOpposite.vue?vue&type=script&lang=js"
export * from "./DynvibeBarOpposite.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__